module.exports = __webpack_public_path__ + "c5a59d660d4001949ee0112812355ef2.svg";